import AdminLayout from "../../components/admin/AdminLayout";
import SubmissionsTable from "../../components/admin/SubmissionsTable";

export default function AdminContact() {
  return (
    <AdminLayout title="Contact Submissions" subtitle="Inquiries from the contact form.">
      <SubmissionsTable type="contact" />
    </AdminLayout>
  );
}
